import React from 'react';
import { UsersIcon } from 'lucide-react';
import { useNotes } from '../../contexts/NotesContext';
import type { Note, Presence } from '../../types/notes';

/**
 * Who else is in this note right now. Presence is ephemeral — it is pushed over
 * a realtime channel and never stored against the note.
 */
export function PresenceBar({
  note,
  presence
}: {
  note: Note;
  presence: Presence[];
}) {
  const {
    coEditing,
    setCoEditing
  } = useNotes();
  if (note.shares.length === 0) return null;
  return <div className="flex flex-wrap items-center gap-2.5 border-b border-line bg-canvas px-5 py-2 sm:px-8" data-id="element-3957" data-mp="tusubett2rfd">
      <UsersIcon className="h-3.5 w-3.5 shrink-0 text-ink-subtle" data-id="element-3958" data-mp="p3ubo8lchh8y" />
      {presence.length === 0 ? <p className="text-[12px] text-ink-muted" data-id="element-3959" data-mp="k6ax17kqj2gh">
          {coEditing ? 'Nobody else is in this note right now.' : 'Live co-editing is switched off for this session.'}
        </p> : <>
          <span className="flex items-center gap-1" data-id="element-3960" data-mp="1csn7m51yvp3k">
            {presence.map(person => <span key={person.handle} title={`${person.displayName} (@${person.handle})`} style={{
          backgroundColor: person.colour
        }} className="flex h-6 w-6 items-center justify-center rounded-full text-[11px] font-semibold text-white" data-id="element-3961" data-mp="1nx7djfu3fou3">
                {person.displayName.split(' ').map(part => part[0]).join('').slice(0, 2)}
              </span>)}
          </span>
          <p className="min-w-0 flex-1 truncate text-[12px] text-ink-muted" data-id="element-3962" data-mp="v8061rcnvowp">
            {presence.map(person => `${person.displayName.split(' ')[0]} is ${person.typing ? 'typing' : 'reading'}`).join(' · ')}
          </p>
        </>}
      <button type="button" onClick={() => setCoEditing(!coEditing)} className="ml-auto text-[12px] font-medium text-brand-800 hover:underline" data-id="element-3963" data-mp="2ulnrhc9xj4i9">
        {coEditing ? 'Turn off live editing' : 'Turn on live editing'}
      </button>
    </div>;
}